<template>
  <div style="background-color: rgb(249, 249, 249);  width: 100%;">
    <div class="d-flex justify-center">
      <v-btn color="green darken-1" small text class="d-flex justify-center" @click="handleGetMainHeight">
        <v-icon size="30" color="green darken-1">mdi-chevron-down</v-icon>
      </v-btn>
    </div>
    <div class="pt-16 pb-16">
      <YA_GrammarFixContent1 />
    </div>
    <!-- <div class="pt-16 pb-16">
      <YA_Customers />
    </div> -->
  </div>
</template>

<script>
import YA_GrammarFixContent1 from '@/components/PowerGrammarFix/YA_GrammarFixContent1.vue';

export default {
  name: 'PowerGrammarFixContent',
  components: {
    YA_GrammarFixContent1,
  },
  data() {
    return {

    }
  },
  mounted() {

  },

  methods: {
    handleGetMainHeight() {
      this.$store.commit('HandlepowerGrammarFixMainHeight', true);
    },
  }

};
</script>

<style scoped>

</style>